import React from 'react'

import styled, { css } from 'styled-components'

import { colors } from '../../constants/colors'
import { FilterTitle, FlexColumnStart, FlexRowBetween, StyledSwitch } from '../projectComponents'
import { SwitchComponent } from './SwitchComponent'

const Block = styled(FlexRowBetween)<{ $sidebar?: boolean }>`
  cursor: pointer;
  margin-right: ${({ $sidebar }) => ($sidebar ? '0' : '12px')};
  position: relative;
  align-items: center;

  ${({ $sidebar }) =>
    $sidebar &&
    css`
      width: 100%;
      min-height: 55px;
      ${StyledSwitch} {
        width: 44px;
        height: 28px;
        span:before {
          width: 22px;
          height: 22px;
          bottom: 3px;
        }
        input:checked + span:before {
          transform: translateX(16px);
        }
      }
    `}

  img {
    height: 18px;
    width: 18px;
  }
`
const Subtitle = styled.p<{ $sidebar?: boolean }>`
  margin: 0;
  font-weight: 500;
  font-size: 13px;
  line-height: ${({ $sidebar }) => ($sidebar ? '23.357px' : 'normal')};
  margin-top: ${({ $sidebar }) => ($sidebar ? '2px' : '0')};
  color: ${colors.grey};
`

interface FilterProps {
  sidebar?: boolean
  subtitle: string
  switchOn: boolean
  title: string
  toggleSwitch: () => void
}

export const InputSwitchWithTitle: React.FC<FilterProps> = ({
  sidebar,
  subtitle,
  switchOn,
  title,
  toggleSwitch,
}) => {
  return (
    <Block $sidebar={sidebar}>
      <FlexColumnStart
        style={sidebar ? { width: '100%' } : { maxWidth: '80%' }}
        onClick={toggleSwitch}
      >
        <FilterTitle>{title}</FilterTitle>
        <Subtitle $sidebar={sidebar}>{subtitle}</Subtitle>
      </FlexColumnStart>
      <div style={sidebar ? { position: 'absolute', right: 0, top: 11 } : undefined}>
        <SwitchComponent checked={switchOn} onChange={toggleSwitch} />
      </div>
    </Block>
  )
}
